@if (store().editing()) {
  <aside class="gr-canvas-editor__bar" role="region" aria-label="Customize layout">
    <div class="gr-canvas-editor__info">
      <span class="material-icons-outlined" aria-hidden="true">tune</span>
      <div class="gr-canvas-editor__text">
        <p class="gr-canvas-editor__title">{{ customizeTitle() }}</p>
        <p class="gr-canvas-editor__subtitle">{{ customizeSubtitle() }}</p>
      </div>
    </div>
    <div class="gr-canvas-editor__actions">
      <span grTooltip="Undo" grTooltipPosition="bottom">
        <gr-button
          variant="secondary"
          size="md"
          ariaLabel="Undo last move or resize"
          leadingIcon="undo"
          [disabled]="!store().canUndo()"
          (grClick)="undo()"
        />
      </span>
      <span grTooltip="Reset to default layout" grTooltipPosition="bottom">
        <gr-button
          variant="secondary"
          size="md"
          ariaLabel="Reset to default layout"
          leadingIcon="restart_alt"
          (grClick)="reset()"
        />
      </span>
      <span grTooltip="Discard changes" grTooltipPosition="bottom">
        <gr-button
          variant="secondary"
          size="md"
          ariaLabel="Discard changes"
          leadingIcon="close"
          (grClick)="cancel()"
        />
      </span>
      <span grTooltip="Save layout" grTooltipPosition="bottom">
        <gr-button
          variant="primary"
          size="md"
          ariaLabel="Save layout"
          leadingIcon="save"
          [disabled]="!store().isDirty()"
          (grClick)="save()"
        />
      </span>
      @if (showBuilder()) {
        <span grTooltip="Widget Builder" grTooltipPosition="bottom">
          <gr-button
            variant="secondary"
            size="md"
            ariaLabel="Widget Builder"
            leadingIcon="widgets"
            (grClick)="builderClick.emit()"
          />
        </span>
      }
      @if (showTableBuilder()) {
        <span grTooltip="Table Builder" grTooltipPosition="bottom">
          <gr-button
            variant="secondary"
            size="md"
            ariaLabel="Table Builder"
            leadingIcon="table_chart"
            (grClick)="tableBuilderClick.emit()"
          />
        </span>
      }
      @if (showChartBuilder()) {
        <span grTooltip="Chart Builder" grTooltipPosition="bottom">
          <gr-button
            variant="secondary"
            size="md"
            ariaLabel="Chart Builder"
            leadingIcon="bar_chart"
            (grClick)="chartBuilderClick.emit()"
          />
        </span>
      }
      @if (addModal()) {
        <span grTooltip="Add widget" grTooltipPosition="bottom">
          <gr-button
            variant="primary"
            size="md"
            ariaLabel="Add widget"
            leadingIcon="add"
            (grClick)="openAdd()"
          />
        </span>
      }
    </div>
  </aside>
}

<ng-content select="[grCanvasEditorTabs]" />

<gr-canvas
  [items]="store().activeLayout()"
  [editing]="store().editing()"
  [editorPadding]="true"
  [renderers]="renderers()"
  [cols]="cols()"
  [rowHeight]="rowHeight()"
  [phantom]="phantom()"
  [minSizeByKind]="store().minSizeByKind"
  [minSizeById]="minSizeById()"
  [emptyLabel]="emptyLabel()"
  [emptyIcon]="emptyIcon()"
  [dragInterceptor]="dragInterceptor()"
  (moved)="onMoved($event)"
  (resized)="onResized($event)"
  (editRequested)="onEditRequested($event)"
  (removeRequested)="onRemoveRequested($event)"
  (deleteRowsRequested)="onDeleteRowsRequested($event)"
>
  <ng-content />
</gr-canvas>
